import { HttpParams } from '@angular/common/http';
import { RMA_JSON_CAMELCASE_HEADER } from '@rma/generic/core/constants';

/**
 * @deprecated please use appendCamelCaseJsonHeader()
 */
export const RMA_DEFAULT_HTTP_OPTIONS = {
  headers: { [RMA_JSON_CAMELCASE_HEADER]: 'true' },
};

export function appendCamelCaseJsonHeader(
  headers: HttpParams | Record<string, string | number | boolean | ReadonlyArray<string | number | boolean>> = {},
) {
  return { headers: { ...headers, [RMA_JSON_CAMELCASE_HEADER]: 'true' } };
}
